import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=ca38097e&"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca38097e')) {
      api.createRecord('ca38097e', component.options)
    } else {
      api.reload('ca38097e', component.options)
    }
    module.hot.accept("./DefaultTemplate.vue?vue&type=template&id=ca38097e&", function () {
      api.rerender('ca38097e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/templates/DefaultTemplate.vue"
export default component.exports